import React, { useState } from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { StatusBadge } from "@/components/common/StatusBadge";
import { CreateDrawer } from "@/components/common/CreateDrawer";
import { Skeletons } from "@/components/common/EmptyState";
import { useResource } from "@/hooks/useResource";
import { Button } from "@/components/ui/button";
import { Camera, Plus, MapPin, CalendarBlank } from "@phosphor-icons/react";

const FIELDS = [
  { name: "name", label: "Shoot Name" },
  { name: "brand", label: "Brand", type: "select" },
  { name: "type", label: "Type", type: "select", options: ["Campaign shoot", "Product shoot", "Model shoot", "Reels", "Flat lay", "Lifestyle shoot"] },
  { name: "location", label: "Location" },
  { name: "photographer", label: "Photographer" },
  { name: "budget", label: "Budget", type: "number" },
  { name: "status", label: "Status", type: "select", options: ["Planned", "Shooting", "Retouching", "Delivered"] },
];

export default function Photoshoots() {
  const { items, isLoading, create } = useResource("photoshoots");
  const [open, setOpen] = useState(false);

  return (
    <div>
      <PageHeader title="Photoshoots" subtitle="Creative production planning & shot boards" icon={Camera}
        actions={<Button onClick={() => setOpen(true)} data-testid="add-btn" className="rounded-full bg-gradient-to-r from-brand-violet to-brand-pink text-white"><Plus size={16} weight="bold" className="mr-1" /> New Shoot</Button>} />
      {isLoading ? <Skeletons /> : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((s, i) => (
            <div key={s.id} data-testid="photoshoot-card" className="overflow-hidden rounded-2xl border border-border bg-surface-raised transition-transform hover:-translate-y-1" style={{ animation: `fade-up 0.4s ease-out ${i * 0.04}s both` }}>
              <div className="relative h-40"><img src={s.cover} alt="" className="h-full w-full object-cover" /><div className="absolute right-3 top-3"><StatusBadge status={s.status} /></div></div>
              <div className="p-4">
                <p className="font-display font-bold">{s.name}</p>
                <p className="text-xs text-muted-foreground">{s.brand} · {s.type}</p>
                <div className="mt-3 space-y-1 text-xs text-muted-foreground">
                  <p className="flex items-center gap-1.5"><CalendarBlank size={13} /> {new Date(s.date).toLocaleDateString(undefined, { day: "numeric", month: "short" })}</p>
                  <p className="flex items-center gap-1.5"><MapPin size={13} /> {s.location}</p>
                </div>
                <div className="mt-3 flex items-center justify-between"><span className="text-xs text-muted-foreground">{s.photographer}</span><span className="font-mono text-sm">₹{(s.budget / 1000).toFixed(0)}K</span></div>
              </div>
            </div>
          ))}
        </div>
      )}
      <CreateDrawer open={open} onOpenChange={setOpen} title="Shoot" fields={FIELDS} submitting={create.isPending}
        onSubmit={(body) => create.mutateAsync({ ...body, date: new Date().toISOString(), cover: "https://images.pexels.com/photos/9888084/pexels-photo-9888084.jpeg?auto=compress&w=800" })} />
    </div>
  );
}
